<!-- views/Admin/CompanyManagement.vue -->
<template>
  <div class="company-management">
    <Navbar :showBackButton="true" @back="goBack" />
    
    <div class="container py-4">
      <!-- Page Header with Gradient -->
      <div class="page-header mb-5">
        <div class="page-header-content">
          <div class="page-icon">🏢</div>
          <div>
            <h1 class="page-title">{{ $t('systemAdmin.companyManagement.title') }}</h1>
            <p class="page-subtitle">{{ $t('systemAdmin.companyManagement.subtitle')}}</p>
          </div>
        </div>
      </div>
      
      <div v-if="loading" class="loading-wrapper">
        <div class="loading-spinner"></div>
        <p class="loading-text">{{ $t('systemAdmin.companyManagement.loading') }}</p>
      </div>
      
      <div v-else-if="companyData" class="company-form">
        <form @submit.prevent="saveCompany">
          <!-- Basic Information Card -->
          <div class="form-card mb-4">
            <div class="form-card-header">
              <div class="header-icon">📋</div>
              <div>
                <h5 class="mb-0">{{ $t('systemAdmin.companyManagement.basic_info') }}</h5>
                <!-- <p class="header-subtitle">Core company information</p> -->
              </div>
            </div>
            <div class="form-card-body">
              <div class="form-grid">
                <div class="form-group">
                  <label class="form-label">{{ $t('systemAdmin.companyManagement.company_name') }}</label>
                  <input v-model="formData.name" type="text" class="  modern-input" placeholder="Enter company name" required>
                </div>
                
                <div class="form-group">
                  <label class="form-label">{{ $t('systemAdmin.companyManagement.national_id') }}</label>
                  <input v-model="formData.national_id" type="text" class=" modern-input" placeholder="National ID">
                </div>
                
                <div class="form-group">
                  <label class="form-label">{{ $t('systemAdmin.companyManagement.economic_id') }}</label>
                  <input v-model="formData.economic_id" type="text" class="  modern-input" placeholder="Economic ID">
                </div>
                
                <div class="form-group">
                  <label class="form-label">{{ $t('systemAdmin.companyManagement.activity_type') }}</label>
                  <input v-model="formData.activity_type" type="text" class="  modern-input" placeholder="Activity type">
                </div>
                
                <div class="form-group">
                  <label class="form-label">{{ $t('systemAdmin.companyManagement.country') }}</label>
                  <input v-model="formData.country" type="text" class="  modern-input" placeholder="Country">
                </div>
                
                <div class="form-group">
                  <label class="form-label">{{ $t('systemAdmin.companyManagement.company_category') }}</label>
                  <select v-model="formData.company_category" class="form-select modern-select">
                    <option value="private">{{ $t('systemAdmin.companyManagement.private') }}</option>
                    <option value="public">{{ $t('systemAdmin.companyManagement.public') }}</option>
                  </select>
                </div>
                
                <div class="form-group">
                  <label class="form-label">{{ $t('systemAdmin.companyManagement.store_category') }}</label>
                  <select v-model="formData.store_category" class="form-select modern-select">
                    <option value="none">{{ $t('systemAdmin.companyManagement.none') }}</option>
                    <option value="private">{{ $t('systemAdmin.companyManagement.private') }}</option>
                    <option value="public">{{ $t('systemAdmin.companyManagement.public') }}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label class="form-label">چیدمان فروشگاه</label>
                  <select v-model="formData.store_layout" class="form-select modern-select">
                    <option value="minimal">حداقلی</option>
                    <option value="large">بزرگ</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Descriptions Card -->
          <div class="form-card mb-4">
            <div class="form-card-header info-header">
              <div class="header-icon">📝</div>
              <div>
                <h5 class="mb-0">{{ $t('systemAdmin.companyManagement.descriptions') }}</h5>
                <!-- <p class="header-subtitle">Tell your company story</p> -->
              </div>
            </div>
            <div class="form-card-body">
              <div class="form-group">
                <label class="form-label">{{ $t('systemAdmin.companyManagement.short_description') }}</label>
                <textarea v-model="formData.description" rows="2" class="  modern-textarea" placeholder="Brief description of your company"></textarea>
                <small class="form-hint">{{ $t('systemAdmin.companyManagement.short_description_hint') }}</small>
              </div>
              
              <div class="form-group mt-3">
                <label class="form-label">{{ $t('systemAdmin.companyManagement.complete_description') }}</label>
                <textarea v-model="formData.complete_description" rows="4" class="  modern-textarea" placeholder="Full company description"></textarea>
                <small class="form-hint">{{ $t('systemAdmin.companyManagement.complete_description_hint') }}</small>
              </div>
            </div>
          </div>
          
          <!-- Contact Information Card -->
          <div class="form-card mb-4">
            <div class="form-card-header success-header">
              <div class="header-icon">📞</div>
              <div>
                <h5 class="mb-0">{{ $t('systemAdmin.companyManagement.contact_info') }}</h5>
                <!-- <p class="header-subtitle">How customers can reach you</p> -->
              </div>
            </div>
            <div class="form-card-body">
              <div class="form-group">
                <label class="form-label">{{ $t('systemAdmin.companyManagement.website') }}</label>
                <input v-model="formData.website_url" type="text" class="  modern-input" placeholder="https://example.com">
              </div>

              <div class="form-group mt-3">
                <label class="form-label">{{ $t('systemAdmin.companyManagement.payment_gateway_url') }}</label>
                <input v-model="formData.payment_gateway_url" type="url" class="modern-input" placeholder="https://novin-sch.ir/payment.html">
                <small class="form-hint">{{ $t('systemAdmin.companyManagement.payment_gateway_url_hint') }}</small>
              </div>
              
              <div class="form-group mt-3">
                <label class="form-label">{{ $t('systemAdmin.companyManagement.address') }}</label>
                <textarea v-model="formData.address" rows="2" class="  modern-textarea" placeholder="Physical address"></textarea>
              </div>
              
              <div class="form-group mt-3">
                <label class="form-label">{{ $t('systemAdmin.companyManagement.postal_code') }}</label>
                <input v-model="formData.post_code" type="text" class="  modern-input" placeholder="Postal code">
              </div>
            </div>
          </div>
          
          <!-- Location Card -->
          <div class="form-card mb-4">
            <div class="form-card-header warning-header">
              <div class="header-icon">📍</div>
              <div>
                <h5 class="mb-0">{{ $t('systemAdmin.companyManagement.location') }}</h5>
              </div>
            </div>
            <div class="form-card-body">
              <!-- Map Container -->
              <div class="location-map-container">
                <div id="location-picker-map" ref="locationMapElement" class="location-map"></div>
              </div>
              
              <!-- Search Box -->
              <div class="location-search-box">
                <div class="search-input-wrapper">
                  <span class="search-icon">🔍</span>
                  <input
                    v-model="locationSearchTerm"
                    @input="handleLocationSearch"
                    type="text"
                    class="modern-input search-input-field"
                    placeholder="جستجوی مکان..."
                  />
                </div>
                <div v-if="locationSearchResults.length" class="search-results-dropdown">
                  <div
                    v-for="item in locationSearchResults"
                    :key="item.title + item.address"
                    class="search-result-item"
                    @click="selectSearchResult(item)"
                  >
                    <strong>{{ item.title }}</strong>
                    <small>{{ item.address }}</small>
                  </div>
                </div>
              </div>
              
              <!-- Coordinate Inputs -->
              <div class="form-grid two-col mt-3" style="display: none;">
                <div class="form-group">
                  <label class="form-label">{{ $t('systemAdmin.companyManagement.latitude') }}</label>
                  <input 
                    v-model="formData.location_lat" 
                    type="number" 
                    step="any" 
                    class="modern-input" 
                    placeholder="Latitude"
                    @input="updateMarkerFromCoordinates"
                  >
                </div>
                
                <div class="form-group">
                  <label class="form-label">{{ $t('systemAdmin.companyManagement.longitude') }}</label>
                  <input 
                    v-model="formData.location_lng" 
                    type="number" 
                    step="any" 
                    class="modern-input" 
                    placeholder="Longitude"
                    @input="updateMarkerFromCoordinates"
                  >
                </div>
              </div>
              
              <!-- Current Location Button -->
              <div class="current-location-btn-wrapper mt-3">
                <button type="button" class="btn-current-location" @click="getCurrentLocation">
                  <span class="btn-icon">📍</span>
                  {{ $t('systemAdmin.companyManagement.use_current_location') }}
                </button>
                <div v-if="isGettingLocation" class="location-loading">
                  <div class="loading-spinner-small"></div>
                  <span>در حال دریافت موقعیت...</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Logo Upload Card -->
          <div class="form-card mb-4">
            <div class="form-card-header secondary-header">
              <div class="header-icon">🖼️</div>
              <div>
                <h5 class="mb-0">{{ $t('systemAdmin.companyManagement.logo') }}</h5>
                <!-- <p class="header-subtitle">Company branding</p> -->
              </div>
            </div>
            <div class="form-card-body">
              <div class="logo-upload-section">
                <div v-if="formData.logo_preview" class="logo-preview-container">
                  <div class="logo-wrapper">
                    <img :src="authStore.proxiedImage(formData.logo_preview)" class="logo-preview" />
                    <button type="button" class="remove-logo-btn" @click="removeLogo">✕</button>
                  </div>
                </div>
                
                <div class="upload-area" :class="{ 'has-logo': formData.logo_preview }">
                  <label class="upload-btn">
                    <span class="upload-icon">📁</span>
                    {{ $t('systemAdmin.companyManagement.select_file') }}
                    <input type="file" @change="uploadLogo" accept="image/*" hidden>
                  </label>
                  <small class="upload-hint">{{ $t('systemAdmin.companyManagement.file_hint') }}</small>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Services Management Card -->
          <div class="form-card mb-4">
            <div class="form-card-header dark-header">
              <div class="header-icon">⚙️</div>
              <div>
                <h5 class="mb-0">{{ $t('systemAdmin.companyManagement.services_features') }}</h5>
                <!-- <p class="header-subtitle">What services you offer</p> -->
              </div>
            </div>
            <div class="form-card-body">
              <div 
                v-for="(service, index) in formData.services" 
                :key="index"
                class="service-item"
              >
                <div class="service-header">
                  <div class="service-number">{{ index + 1 }}</div>
                  <h6 class="service-title">Service Details</h6>
                  <button 
                    v-if="index > 0" 
                    type="button" 
                    class="remove-service-btn"
                    @click="removeService(index)"
                  >✕</button>
                </div>
                
                <div class="service-body">
                  <div class="form-group">
                    <label class="form-label">{{ $t('systemAdmin.companyManagement.service_title') }}</label>
                    <input v-model="service.title" type="text" class="  modern-input" :placeholder="$t('systemAdmin.companyManagement.service_title_placeholder')">
                  </div>
                  
                  <div class="form-group mt-3">
                    <label class="form-label">{{ $t('systemAdmin.companyManagement.service_description') }}</label>
                    <textarea v-model="service.description" rows="2" class="  modern-textarea" :placeholder="$t('systemAdmin.companyManagement.service_description_placeholder')"></textarea>
                  </div>
                  
                  <div class="service-image-upload mt-3">
                    <label class="form-label">Service Image</label>
                    <div v-if="service.image_preview" class="service-image-preview-container">
                      <img :src="authStore.proxiedImage(service.image_preview)" class="service-image-preview" />
                      <button type="button" class="remove-image-btn" @click="removeServiceImage(index)">✕</button>
                    </div>
                    <label class="upload-image-btn">
                      <span class="upload-icon">🖼️</span>
                      {{ $t('systemAdmin.companyManagement.select_image') }}
                      <input type="file" @change="(e) => uploadServiceImage(e, index)" accept="image/*" hidden>
                    </label>
                  </div>
                </div>
              </div>
              
              <button 
                v-if="formData.services.length < 4" 
                type="button" 
                class="add-service-btn"
                @click="addService"
              >
                <span class="plus-icon">+</span> {{ $t('systemAdmin.companyManagement.add_service') }}
              </button>
            </div>
          </div>

          <!-- Why Select This Company Card -->
          <div class="form-card mb-4">
            <div class="form-card-header info-header">
              <div class="header-icon">⭐</div>
              <div>
                <h5 class="mb-0">{{ $t('systemAdmin.companyManagement.why_select_title') }}</h5>
                <p class="header-subtitle">{{ $t('systemAdmin.companyManagement.why_select_subtitle') }}</p>
              </div>
            </div>
            <div class="form-card-body">
              <div 
                v-for="(item, index) in formData.why_select_items" 
                :key="index"
                class="why-select-item"
              >
                <div class="why-select-header">
                  <div class="why-select-number">{{ index + 1 }}</div>
                  <h6 class="why-select-title">{{ $t('systemAdmin.companyManagement.feature') }} {{ index + 1 }}</h6>
                  <button 
                    v-if="index > 0" 
                    type="button" 
                    class="remove-why-select-btn"
                    @click="removeWhySelectItem(index)"
                  >✕</button>
                </div>
                
                <div class="why-select-body">
                  <div class="form-group">
                    <label class="form-label">{{ $t('systemAdmin.companyManagement.feature_icon') }}</label>
                    <input 
                      v-model="item.icon" 
                      type="text" 
                      class="modern-input" 
                      placeholder="🔒 💰 📊 🤝 (Emoji or icon text)"
                    >
                    <small class="form-hint">{{ $t('systemAdmin.companyManagement.feature_icon_hint') }}</small>
                  </div>
                  
                  <div class="form-group mt-3">
                    <label class="form-label">{{ $t('systemAdmin.companyManagement.feature_title') }}</label>
                    <input 
                      v-model="item.title" 
                      type="text" 
                      class="modern-input" 
                      :placeholder="$t('systemAdmin.companyManagement.feature_title_placeholder')"
                    >
                  </div>
                  
                  <div class="form-group mt-3">
                    <label class="form-label">{{ $t('systemAdmin.companyManagement.feature_description') }}</label>
                    <textarea 
                      v-model="item.description" 
                      rows="2" 
                      class="modern-textarea" 
                      :placeholder="$t('systemAdmin.companyManagement.feature_description_placeholder')"
                    ></textarea>
                  </div>
                </div>
              </div>
              
              <button 
                v-if="formData.why_select_items.length < 4" 
                type="button" 
                class="add-why-select-btn"
                @click="addWhySelectItem"
              >
                <span class="plus-icon">+</span> {{ $t('systemAdmin.companyManagement.add_feature') }}
              </button>
            </div>
          </div>
          
          <!-- Settings Card -->
          <div class="form-card mb-4">
            <div class="form-card-header dark-header">
              <div class="header-icon">⚙️</div>
              <div>
                <h5 class="mb-0">{{ $t('systemAdmin.companyManagement.settings') }}</h5>
                <!-- <p class="header-subtitle">Configure company preferences</p> -->
              </div>
            </div>
            <div class="form-card-body">
              <div class="settings-grid">
                <div class="setting-item">
                  <label class="setting-label">{{ $t('systemAdmin.companyManagement.currency') }}</label>
                  <select v-model="formData.vahed_pool" class="form-select modern-select">
                    <option :value="1">{{ $t('systemAdmin.companyManagement.rial') }}</option>
                    <option :value="2">{{ $t('systemAdmin.companyManagement.toman') }}</option>
                    <option :value="3">{{ $t('systemAdmin.companyManagement.dollar') }}</option>
                  </select>
                </div>
                
                <div class="setting-item checkbox-item">
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="formData.multi_arz" class="modern-checkbox">
                    <span class="checkbox-text">{{ $t('systemAdmin.companyManagement.multi_currency') }}</span>
                  </label>
                </div>
                
                <div class="setting-item checkbox-item">
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="formData.active" class="modern-checkbox">
                    <span class="checkbox-text">{{ $t('systemAdmin.companyManagement.company_active') }}</span>
                  </label>
                </div>
              </div>
            </div>
            
            <div class="form-card-body">
              <!-- Theme Selection -->
              <div class="mb-4">
                <label class="form-label">تم صفحه</label>

                <div class="theme-grid">
                  <div
                    v-for="theme in themeOptions"
                    :key="theme.value"
                    class="theme-card"
                    :class="[
                      `theme-preview-${theme.value}`,
                      { active: formData.landing_theme === theme.value }
                    ]"
                    @click="formData.landing_theme = theme.value"
                  >
                    <div class="theme-preview">
                      <div class="theme-bar"></div>
                      <div class="theme-content">
                        <div class="theme-line"></div>
                        <div class="theme-line small"></div>
                      </div>
                    </div>

                    <div class="theme-name">{{ theme.label }}</div>
                  </div>
                </div>
              </div>

              <!-- Layout Selection -->
              <div class="mb-4">
                <label class="form-label">فرمت صفحه</label>

                <div class="layout-grid">
                  <div
                    v-for="layout in layoutOptions"
                    :key="layout.value"
                    class="layout-card"
                    :class="{ active: formData.landing_layout === layout.value }"
                    @click="formData.landing_layout = layout.value"
                  >
                    <div class="layout-preview" :class="'layout-preview-' + layout.value">
                      <div class="hero"></div>
                      <div class="content">
                        <div class="box"></div>
                        <div class="box"></div>
                        <div class="box"></div>
                      </div>
                    </div>

                    <div class="layout-name">{{ layout.label }}</div>
                  </div>
                </div>
              </div>

              <!-- Section visibility -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" v-model="formData.show_stats" id="showStats">
                    <label class="form-check-label" for="showStats">نمایش آمار</label>
                  </div>

                  <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" v-model="formData.show_map" id="showMap">
                    <label class="form-check-label" for="showMap">نمایش نقشه</label>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" v-model="formData.show_services" id="showServices">
                    <label class="form-check-label" for="showServices">نمایش خدمات</label>
                  </div>

                  <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" v-model="formData.show_why_select" id="showWhy">
                    <label class="form-check-label" for="showWhy">نمایش بخش چرا ما</label>
                  </div>

                  <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" v-model="formData.show_child_img" id="showChildImg">
                    <label class="form-check-label" for="showWhy">نمایش عکس کالاها</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Action Buttons -->
          <div class="action-buttons">
            <button type="submit" class="btn-save" :disabled="saving">
              <span v-if="saving" class="btn-spinner"></span>
              <span v-else class="btn-icon">💾</span>
              {{ $t('systemAdmin.companyManagement.save_changes') }}
            </button>
            <button type="button" class="btn-cancel" @click="resetForm">{{ $t('systemAdmin.companyManagement.cancel') }}</button>
          </div>
        </form>
      </div>
    </div>
    
    <!-- Toast Notifications -->
    <div class="toast-notification" :class="{ show: showToast, success: toastType === 'success', error: toastType === 'error' }">
      <div class="toast-content">
        <span class="toast-icon">{{ toastType === 'success' ? '✓' : '✕' }}</span>
        <span class="toast-message">{{ toastMessage }}</span>
        <button class="toast-close" @click="showToast = false">✕</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { adminCompanyService, MapService } from '@/services/api'
import Navbar from '@/components/Navbar.vue'
import nmp from "@neshan-maps-platform/mapbox-gl"

export default {
  name: 'CompanyManagement',
  components: { Navbar },
  setup() {
    const router = useRouter()
    const authStore = useAuthStore()
    
    const loading = ref(false)
    const saving = ref(false)
    const companyData = ref(null)
    
    // Map refs
    const locationMapElement = ref(null)
    let locationMap = null
    let locationMarker = null
    let locationSearchTimeout = null
    const locationSearchTerm = ref('')
    const locationSearchResults = ref([])
    
    const formData = ref({
      name: '',
      national_id: '',
      economic_id: '',
      activity_type: '',
      description: '',
      complete_description: '',
      country: '',
      website_url: '',
      payment_gateway_url: '',
      address: '',
      post_code: '',
      location_lat: null,
      location_lng: null,
      company_category: 'private',
      store_category: '',
      store_layout: 'minimal',
      vahed_pool: 1,
      multi_arz: false,
      active: true,
      logo_preview: null,
      services: [],
      why_select_items: [],

      landing_theme: 'classic',
      landing_layout: 'default',
      show_stats: true,
      show_map: true,
      show_services: true,
      show_why_select: true,
      show_child_img: false,
    })

    const themeOptions = [
      { value: 'classic', label: 'کلاسیک' },
      { value: 'modern', label: 'مدرن' },
      { value: 'dark', label: 'تیره' },
      { value: 'light', label: 'روشن' },
      { value: 'gradient', label: 'گرادینت' }
    ]

    const layoutOptions = [
      { value: 'default', label: 'پیش‌فرض' },
      { value: 'compact', label: 'فشرده' },
      { value: 'full', label: 'کامل' },
      { value: 'minimal', label: 'مینیمال' }
    ]

    
    const showToast = ref(false)
    const toastMessage = ref('')
    const toastType = ref('success')
    
    // Get current company ID from auth store
    const currentCompanyId = computed(() => authStore.getSelectedCompanyId)
    
    // Load company data
    const loadCompany = async () => {
      if (!currentCompanyId.value) {
        showMessage('شرکتی انتخاب نشده است', 'error')
        return
      }
      
      loading.value = true
      try {
        const response = await adminCompanyService.getCompany(currentCompanyId.value)
        
        if (response.data.success) {
          companyData.value = response.data.data
          
          // Populate form
          formData.value = {
            name: companyData.value.name || '',
            national_id: companyData.value.national_id || '',
            economic_id: companyData.value.economic_id || '',
            activity_type: companyData.value.activity_type || '',
            description: companyData.value.description || '',
            complete_description: companyData.value.complete_description || '',
            country: companyData.value.country || '',
            website_url: companyData.value.website_url || '',
            payment_gateway_url: companyData.value.payment_gateway_url || '',
            address: companyData.value.address || '',
            post_code: companyData.value.post_code || '',
            location_lat: companyData.value.location?.lat || null,
            location_lng: companyData.value.location?.lng || null,
            company_category: companyData.value.company_category || 'private',
            store_category: companyData.value.store_category || '',
            store_layout: companyData.value.store_layout || 'minimal',
            vahed_pool: companyData.value.vahed_pool || 1,
            multi_arz: companyData.value.multi_arz || false,
            active: companyData.value.active !== false,
            logo_preview: companyData.value.logo_url || null,

            services: companyData.value.services || [],

            landing_theme: companyData.value.landing_theme || 'classic',
            landing_layout: companyData.value.landing_layout || 'default',

            show_stats: companyData.value.show_stats !== false,
            show_map: companyData.value.show_map !== false,
            show_services: companyData.value.show_services !== false,
            show_why_select: companyData.value.show_why_select !== false,
            show_child_img: companyData.value.Show_child_img !== false,

          }
          
          formData.value.why_select_items = companyData.value.why_select_items || []

          // Add image previews for services
          formData.value.services.forEach(service => {
              if (service.image_url) {
                service.image_preview = service.image_url
              }
          })
          
          // Initialize location map after data is loaded and DOM is ready
          nextTick(() => {
            setTimeout(() => {
              initLocationPickerMap()
            }, 500)
          })
        }
      } catch (error) {
        console.error('Error loading company:', error)
        showMessage('خطا در بارگذاری اطلاعات شرکت', 'error')
      } finally {
        loading.value = false
      }
    }
    
    // Initialize location picker map
    const initLocationPickerMap = () => {
      if (!locationMapElement.value) return
      
      // Check if nmp is available
      if (typeof nmp === 'undefined') {
        setTimeout(() => {
          initLocationPickerMap()
        }, 500)
        return
      }
      
      // Destroy existing map if any
      if (locationMap) {
        try {
          locationMap.remove()
          locationMap = null
        } catch(e) {
          // Ignore
        }
      }
      
      const centerLat = formData.value.location_lat || 35.6892
      const centerLng = formData.value.location_lng || 51.3890
      
      try {
        locationMap = new nmp.Map({
          mapKey: 'web.73a02790728f4a38862451622ccb92d7',
          container: locationMapElement.value,
          center: [centerLng, centerLat],
          zoom: 13,
          mapType: 'neshanVectorNight',
        })
        
        locationMap.on('load', () => {
          if (formData.value.location_lat && formData.value.location_lng) {
            addLocationMarker(formData.value.location_lat, formData.value.location_lng)
          }
        })
        
        locationMap.on('click', (e) => {
          const { lng, lat } = e.lngLat
          setLocation(lat, lng)
        })
        
        // Suppress the specific error
        locationMap.on('error', (e) => {
          if (e.error && e.error.message && e.error.message.includes('message channel closed')) {
            // Ignore this specific error
            return
          }
          console.error('Map error:', e)
        })
      } catch (error) {
        // Ignore extension-related errors
        if (!error.message || !error.message.includes('message channel closed')) {
          console.error('Error initializing map:', error)
        }
      }
    }
    
    // Add marker to map
    const addLocationMarker = (lat, lng) => {
      if (!locationMap) return
      
      // Remove existing marker
      if (locationMarker) {
        try {
          locationMarker.remove()
        } catch(e) {
          console.warn('Error removing marker:', e)
        }
      }
      
      try {
        // Create new marker
        locationMarker = new nmp.Marker({
          draggable: true
        })
          .setLngLat([lng, lat])
          .addTo(locationMap)
        
        // Handle marker drag end
        locationMarker.on('dragend', () => {
          const { lng, lat } = locationMarker.getLngLat()
          setLocation(lat, lng)
        })
      } catch (error) {
        console.error('Error adding marker:', error)
      }
    }
    
    // Set location (updates form and map)
    const setLocation = (lat, lng) => {
      formData.value.location_lat = lat
      formData.value.location_lng = lng
      
      // Update marker position
      if (locationMarker) {
        try {
          locationMarker.setLngLat([lng, lat])
        } catch(e) {
          console.warn('Error updating marker position:', e)
        }
      } else {
        addLocationMarker(lat, lng)
      }
      
      // Center map on new location
      if (locationMap) {
        try {
          locationMap.flyTo({
            center: [lng, lat],
            zoom: 15,
            speed: 0.8
          })
        } catch(e) {
          console.warn('Error centering map:', e)
        }
      }
    }
    
    // Update marker from coordinate inputs
    const updateMarkerFromCoordinates = () => {
      const lat = parseFloat(formData.value.location_lat)
      const lng = parseFloat(formData.value.location_lng)
      
      if (!isNaN(lat) && !isNaN(lng) && lat && lng) {
        if (locationMap) {
          try {
            locationMap.setCenter([lng, lat])
            locationMap.setZoom(15)
          } catch(e) {
            console.warn('Error updating map center:', e)
          }
        }
        
        if (locationMarker) {
          try {
            locationMarker.setLngLat([lng, lat])
          } catch(e) {
            console.warn('Error updating marker position:', e)
          }
        } else {
          addLocationMarker(lat, lng)
        }
      }
    }
    
    // Search for locations - Fixed version
    const handleLocationSearch = async () => {
      if (locationSearchTimeout) {
        clearTimeout(locationSearchTimeout)
      }
      
      locationSearchTimeout = setTimeout(async () => {
        const searchText = locationSearchTerm.value.trim()
        if (searchText.length < 2) {
          locationSearchResults.value = []
          return
        }
        
        try {
          if (!locationMap) {
            console.warn('Map not ready for search')
            return
          }
          
          const center = locationMap.getCenter()
          const lat = center.lat
          const lng = center.lng
          
          console.log(`Searching for: "${searchText}" at (${lat}, ${lng})`)
          
          // Use the MapService
          const data = await MapService.searchLocation(searchText, lat, lng)
          
          if (data && data.items && data.items.length > 0) {
            locationSearchResults.value = data.items.map(item => ({
              title: item.title,
              address: item.address,
              location: {
                x: item.location.x,
                y: item.location.y
              }
            }))
            console.log(`Found ${locationSearchResults.value.length} results`)
          } else {
            locationSearchResults.value = []
            console.log('No results found')
          }
        } catch (err) {
          console.error('Search error:', err)
          locationSearchResults.value = []
          
          // Show user-friendly error message
          if (err.message?.includes('481') || err.message?.includes('LimitExceeded')) {
            showMessage('محدودیت جستجو به پایان رسیده است', 'error')
          } else if (err.message?.includes('480') || err.message?.includes('KeyNotFound')) {
            showMessage('مشکل در ارتباط با سرویس جستجو', 'error')
          }
        }
      }, 400)
    }

    // Select search result and center map
    const selectSearchResult = (item) => {
      if (!item || !item.location) {
        console.warn('Invalid search result selected')
        return
      }
      
      const lng = item.location.x
      const lat = item.location.y
      
      console.log(`Selected location: ${item.title} at (${lat}, ${lng})`)
      
      setLocation(lat, lng)
      
      // Clear search results and term
      locationSearchResults.value = []
      locationSearchTerm.value = item.title
    }

// Get current location with better error handling and fallback
const isGettingLocation = ref(false)

const getCurrentLocation = (retryCount = 0) => {
  // Check if browser supports geolocation
  if (!navigator.geolocation) {
    showMessage('مرورگر شما از موقعیت مکانی پشتیبانی نمی‌کند. لطفاً موقعیت را به صورت دستی روی نقشه انتخاب کنید.', 'error')
    return
  }
  
  // Check if we're in a secure context (HTTPS or localhost)
  const isSecureContext = window.isSecureContext || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  if (!isSecureContext) {
    showMessage('برای دریافت موقعیت مکانی به اتصال امن (HTTPS) نیاز است. لطفاً موقعیت را دستی انتخاب کنید.', 'error')
    return
  }
  
  isGettingLocation.value = true
  
  // Show initial message
  showMessage('در حال دریافت موقعیت مکانی...', 'success')
  
  const options = {
    enableHighAccuracy: false,  // Start with false for faster response
    timeout: 200000,             // 200 seconds timeout
    maximumAge: 60000           // Accept cached position up to 1 minute
  }
  
  // First try with lower accuracy for speed
  navigator.geolocation.getCurrentPosition(
    (position) => {
      isGettingLocation.value = false
      const { latitude, longitude } = position.coords
      const accuracy = position.coords.accuracy
      
      console.log(`Location obtained: lat=${latitude}, lng=${longitude}, accuracy=${accuracy}m`)
      
      if (accuracy > 1000) {
        showMessage(`موقعیت با دقت کم (خطا: ${Math.round(accuracy)} متر). لطفاً موقعیت را تنظیم کنید.`, 'success')
      } else {
        showMessage('موقعیت فعلی شما با موفقیت ثبت شد', 'success')
      }
      
      setLocation(latitude, longitude)
    },
    (error) => {
      console.error(`Geolocation error (attempt ${retryCount + 1}):`, error)
      
      // If first attempt fails with low accuracy, try with high accuracy
      if (retryCount === 0 && error.code !== error.PERMISSION_DENIED) {
        console.log('Retrying with high accuracy...')
        showMessage('تلاش مجدد با دقت بالاتر...', 'success')
        
        const highAccuracyOptions = {
          enableHighAccuracy: true,
          timeout: 25000,
          maximumAge: 0
        }
        
        navigator.geolocation.getCurrentPosition(
          (highAccuracyPosition) => {
            isGettingLocation.value = false
            const { latitude, longitude } = highAccuracyPosition.coords
            showMessage('موقعیت فعلی شما با موفقیت ثبت شد', 'success')
            setLocation(latitude, longitude)
          },
          (highAccuracyError) => {
            isGettingLocation.value = false
            handleGeolocationError(highAccuracyError)
          },
          highAccuracyOptions
        )
      } else {
        isGettingLocation.value = false
        handleGeolocationError(error)
      }
    },
    options
  )
}

// Helper function to handle geolocation errors
const handleGeolocationError = (error) => {
  let errorMessage = ''
  let shouldShowManualHelp = false
  
  switch(error.code) {
    case error.PERMISSION_DENIED:
      errorMessage = 'دسترسی به موقعیت مکانی مجاز نیست. لطفاً دسترسی را در تنظیمات مرورگر فعال کنید یا موقعیت را دستی انتخاب کنید.'
      shouldShowManualHelp = true
      break
    case error.POSITION_UNAVAILABLE:
      errorMessage = 'اطلاعات موقعیت مکانی در دسترس نیست. لطفاً موقعیت را به صورت دستی روی نقشه انتخاب کنید.'
      shouldShowManualHelp = true
      break
    case error.TIMEOUT:
      errorMessage = 'دریافت موقعیت به طول انجامید. لطفاً موقعیت را به صورت دستی روی نقشه انتخاب کنید.'
      shouldShowManualHelp = true
      break
    default:
      errorMessage = 'خطا در دریافت موقعیت مکانی. لطفاً موقعیت را دستی انتخاب کنید.'
      shouldShowManualHelp = true
      break
  }
  
  showMessage(errorMessage, 'error')
  
  // Show manual help dialog if needed
  if (shouldShowManualHelp) {
    setTimeout(() => {
      const confirmManual = confirm('آیا می‌خواهید راهنمایی برای تنظیم دستی موقعیت دریافت کنید؟')
      if (confirmManual) {
        showManualLocationHelp()
      }
    }, 500)
  }
}

// Show manual location guidance
const showManualLocationHelp = () => {
  const helpMessage = `تنظیم دستی موقعیت مکانی:
  
  ۱. روی نقشه کلیک کنید تا نقطه مورد نظر مشخص شود
  ۲. می‌توانید نشانگر را با ماوس جابجا کنید
  ۳. از جستجو برای پیدا کردن آدرس استفاده کنید
  ۴. برای دقت بیشتر، می‌توانید روی نقشه زوم کنید
  
  آیا راهنمایی بیشتری نیاز دارید؟`
  
  alert(helpMessage)
}
    
    // Upload logo
    const uploadLogo = async (event) => {
      const file = event.target.files[0]
      if (!file) return
      
      if (file.size > 2 * 1024 * 1024) {
        showMessage('حجم فایل باید کمتر از ۲ مگابایت باشد', 'error')
        return
      }
      
      try {
        const response = await adminCompanyService.uploadLogo(currentCompanyId.value, file)
        
        if (response.data.success) {
          formData.value.logo_preview = response.data.logo_url
          showMessage('لوگو با موفقیت آپلود شد', 'success')
        }

      } catch (error) {
        console.error('Error uploading logo:', error)
        showMessage('خطا در آپلود لوگو', 'error')
      }
    }
    
    // Upload service image
    const uploadServiceImage = async (event, index) => {
      const file = event.target.files[0]
      if (!file) return
      
      if (file.size > 2 * 1024 * 1024) {
        showMessage('حجم فایل باید کمتر از ۲ مگابایت باشد', 'error')
        return
      }
      
      try {
        const response = await adminCompanyService.uploadServiceImage(currentCompanyId.value, index + 1, file)
        
        if (response.data.success) {
          formData.value.services[index].image_preview = response.data.image_url
          formData.value.services[index].image_url = response.data.image_url

          showMessage('تصویر خدمت با موفقیت آپلود شد', 'success')
        }

      } catch (error) {
        console.error('Error uploading service image:', error)
        showMessage('خطا در آپلود تصویر خدمت', 'error')
      }
    }
    
    // Remove logo
    const removeLogo = () => {
      formData.value.logo_preview = null
      showMessage('لوگو حذف شد. برای ذخیره تغییرات دکمه ذخیره را بزنید', 'success')
    }
    
    // Remove service image
    const removeServiceImage = (index) => {
      formData.value.services[index].image_preview = null
      formData.value.services[index].image_url = null
    }
    
    // Add service
    const addService = () => {
      formData.value.services.push({
        title: '',
        description: '',
        image_url: null,
        image_preview: null
      })
    }
    
    // Remove service
    const removeService = (index) => {
      formData.value.services.splice(index, 1)
    }
    
    // Save company
    const saveCompany = async () => {
      saving.value = true
      
      try {
        const updateData = {
          company_name: formData.value.name || null,
          description: formData.value.description || null,
          complete_description: formData.value.complete_description || null,
          activity_type: formData.value.activity_type || null,
          country: formData.value.country || null,
          national_id: formData.value.national_id || null,
          economic_id: formData.value.economic_id || null,
          company_website_url: formData.value.website_url || null,
          payment_gateway_url: formData.value.payment_gateway_url.trim(),
          company_address: formData.value.address || null,
          post_code: formData.value.post_code || null,
          location_lat: formData.value.location_lat ? parseFloat(formData.value.location_lat) : null,
          location_lng: formData.value.location_lng ? parseFloat(formData.value.location_lng) : null,
          company_category: formData.value.company_category || null,
          store_category: formData.value.store_category || null,
          store_layout: formData.value.store_layout || 'minimal',
          vahed_pool: parseInt(formData.value.vahed_pool),
          multi_arz: formData.value.multi_arz === true,
          active: formData.value.active === true,
          services: formData.value.services.map(s => ({
            title: s.title || '',
            description: s.description || '',
            image_url: s.image_url || null
          })),

          why_select_items: formData.value.why_select_items.map(item => ({
            icon: item.icon || null,
            title: item.title || null,
            description: item.description || null
          })),

          landing_theme: formData.value.landing_theme,
          landing_layout: formData.value.landing_layout,

          show_stats: formData.value.show_stats === true,
          show_map: formData.value.show_map === true,
          show_services: formData.value.show_services === true,
          show_why_select: formData.value.show_why_select === true,
          show_child_img: formData.value.show_child_img === true,
        }
        
        // Remove undefined values
        Object.keys(updateData).forEach(key => {
          if (updateData[key] === undefined) {
            delete updateData[key]
          }
        })
        
        console.log('Sending update data:', updateData)
        
        const response = await adminCompanyService.updateCompany(currentCompanyId.value, updateData)
        
        if (response.data.success) {
          showMessage('اطلاعات شرکت با موفقیت ذخیره شد', 'success')
        }
      } catch (error) {
        console.error('Error saving company:', error)
        showMessage('خطا در ذخیره اطلاعات: ' + (error.response?.data?.detail || error.message), 'error')
      } finally {
        saving.value = false
      }
    }
    
    // Reset form
    const resetForm = () => {
      if (companyData.value) {
        loadCompany()
      }
    }
    
    // Show message
    const showMessage = (message, type) => {
      toastMessage.value = message
      toastType.value = type
      showToast.value = true
      setTimeout(() => {
        showToast.value = false
      }, 3000)
    }
    
    const goBack = () => {
      router.push('/admin/dashboard')
    }

    // Add Why Select item
    const addWhySelectItem = () => {
      formData.value.why_select_items.push({
        icon: '',
        title: '',
        description: ''
      })
    }

    // Remove Why Select item
    const removeWhySelectItem = (index) => {
      formData.value.why_select_items.splice(index, 1)
    }
    
    // Clean up map on unmount
    onUnmounted(() => {
      if (locationMap) {
        try {
          locationMap.remove()
        } catch(e) {
          console.warn('Error removing map on unmount:', e)
        }
      }
    })
    
    onMounted(() => {
      loadCompany()
    })
    
    return {
      loading,
      saving,
      companyData,
      formData,
      locationMapElement,
      locationSearchTerm,
      locationSearchResults,
      showToast,
      toastMessage,
      toastType,
      uploadLogo,
      uploadServiceImage,
      removeLogo,
      removeServiceImage,
      addService,
      removeService,
      saveCompany,
      resetForm,
      goBack,
      handleLocationSearch,
      selectSearchResult,
      getCurrentLocation,
      updateMarkerFromCoordinates,
      addWhySelectItem,
      removeWhySelectItem,
      authStore,
      themeOptions,
      layoutOptions
    }
  }
}
</script>

<style scoped>
/* Theme Variables - Inherited from parent */
.company-management {
  background: var(--bg);
  min-height: 100vh;
  padding-bottom: 40px;
}

/* Page Header */
.page-header {
  background: linear-gradient(135deg, var(--gradient-1) 0%, var(--gradient-2) 100%);
  border-radius: 24px;
  padding: 32px;
  margin-bottom: 32px;
  box-shadow: 0 8px 32px var(--shadow-2);
}

.page-header-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.page-icon {
  font-size: 48px;
  background: rgba(255, 255, 255, 0.2);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: white;
  margin: 0 0 8px 0;
}

.page-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

/* Loading State */
.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px;
  background: var(--card-bg);
  border-radius: 24px;
  border: 1px solid var(--card-border);
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 3px solid var(--card-border);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.loading-text {
  margin-top: 16px;
  color: var(--subtext);
  font-size: 14px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Form Cards */
.form-card {
  background: var(--card-bg);
  border-radius: 20px;
  border: 1px solid var(--card-border);
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
}

.form-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px var(--shadow-1);
}

.form-card-header {
  padding: 20px 24px;
  background: linear-gradient(135deg, var(--gradient-1) 0%, var(--gradient-2) 100%);
  display: flex;
  align-items: center;
  gap: 14px;
}

.form-card-header.info-header {
  background: linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%);
}

.form-card-header.success-header {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.form-card-header.warning-header {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.form-card-header.secondary-header {
  background: linear-gradient(135deg, #64748b 0%, #475569 100%);
}

.form-card-header.dark-header {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
}

.header-icon {
  font-size: 28px;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-card-header h5 {
  color: white;
  font-weight: 600;
}

.header-subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  margin: 4px 0 0 0;
}

.form-card-body {
  padding: 24px;
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.form-grid.two-col {
  grid-template-columns: repeat(2, 1fr);
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

/* Form Elements */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 18px;
  font-weight: 600;
  color: var(--heading);
  margin: 0;
}

.modern-input,
.modern-select,
.modern-textarea {
  padding: 12px 16px;
  border: 2px solid var(--card-border);
  border-radius: 12px;
  font-size: 16px;
  background: var(--bg);
  color: var(--text);
  transition: all 0.2s;
  font-family: inherit;
}

.modern-input:focus,
.modern-select:focus,
.modern-textarea:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--ring);
}

.modern-textarea {
  resize: vertical;
  min-height: 80px;
}

.form-hint {
  font-size: 11px;
  color: var(--muted);
  margin-top: 4px;
}

/* Logo Upload */
.logo-upload-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.logo-preview-container {
  display: flex;
  justify-content: center;
}

.logo-wrapper {
  position: relative;
  display: inline-block;
}

.logo-preview {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--primary);
  background: white;
  padding: 4px;
}

.remove-logo-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--orange-1);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s;
}

.remove-logo-btn:hover {
  transform: scale(1.1);
  background: var(--orange-2);
}

.upload-area {
  text-align: center;
  padding: 24px;
  border: 2px dashed var(--card-border);
  border-radius: 16px;
  background: var(--bg);
  transition: all 0.2s;
}

.upload-area:hover {
  border-color: var(--primary);
  background: var(--ring);
}

.upload-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: var(--primary);
  color: white;
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.upload-btn:hover {
  background: var(--primary-hover);
  transform: translateY(-2px);
}

.upload-icon {
  font-size: 18px;
}

.upload-hint {
  display: block;
  margin-top: 12px;
  font-size: 12px;
  color: var(--muted);
}

/* Service Items */
.service-item {
  background: var(--bg);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid var(--card-border);
}

.service-item:last-child {
  margin-bottom: 0;
}

.service-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--card-border);
}

.service-number {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 14px;
}

.service-title {
  flex: 1;
  margin: 0;
  color: var(--heading);
  font-size: 15px;
}

.remove-service-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s;
}

.remove-service-btn:hover {
  background: #ef4444;
  color: white;
  transform: scale(1.05);
}

/* Service Image */
.service-image-preview-container {
  position: relative;
  display: inline-block;
  margin-bottom: 12px;
}

.service-image-preview {
  width: 120px;
  height: 80px;
  border-radius: 12px;
  object-fit: cover;
  border: 2px solid var(--card-border);
}

.remove-image-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--orange-1);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.upload-image-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: var(--bg);
  border: 1px solid var(--card-border);
  border-radius: 10px;
  cursor: pointer;
  font-size: 13px;
  color: var(--text);
  transition: all 0.2s;
}

.upload-image-btn:hover {
  border-color: var(--primary);
  background: var(--ring);
}

/* Add Service Button */
.add-service-btn {
  width: 100%;
  padding: 14px;
  background: transparent;
  border: 2px dashed var(--card-border);
  border-radius: 16px;
  margin-top: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--primary);
  transition: all 0.2s;
}

.add-service-btn:hover {
  border-color: var(--primary);
  background: var(--ring);
}

.plus-icon {
  font-size: 18px;
  font-weight: bold;
}

/* Settings Grid */
.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.setting-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.setting-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--heading);
}

.checkbox-item {
  justify-content: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
  color: var(--text);
}

.modern-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--primary);
}

.checkbox-text {
  user-select: none;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 32px;
}

.btn-save {
  padding: 14px 32px;
  background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
  color: white;
  border: none;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s;
}

.btn-save:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px var(--shadow-2);
}

.btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-icon {
  font-size: 16px;
}

.btn-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

.btn-cancel {
  padding: 14px 24px;
  background: transparent;
  border: 2px solid var(--card-border);
  border-radius: 14px;
  font-size: 14px;
  font-weight: 600;
  color: var(--subtext);
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel:hover {
  border-color: var(--orange-1);
  color: var(--orange-1);
  background: rgba(249, 115, 22, 0.05);
}

/* Map Preview */
.modern-map {
  height: 300px;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid var(--card-border);
}

/* Toast Notification */
.toast-notification {
  position: fixed;
  bottom: 24px;
  right: 24px;
  min-width: 300px;
  background: var(--card-bg);
  border-radius: 12px;
  box-shadow: 0 8px 24px var(--shadow-2);
  transform: translateX(400px);
  transition: transform 0.3s ease;
  z-index: 1050;
  border: 1px solid var(--card-border);
}

.toast-notification.show {
  transform: translateX(0);
}

.toast-notification.success {
  border-right: 4px solid var(--green);
}

.toast-notification.error {
  border-right: 4px solid var(--orange-1);
}

.toast-content {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  gap: 12px;
}

.toast-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--green);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
}

.toast-notification.error .toast-icon {
  background: var(--orange-1);
}

.toast-message {
  flex: 1;
  font-size: 14px;
  color: var(--text);
}

.toast-close {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: var(--muted);
  padding: 4px;
}

.toast-close:hover {
  color: var(--text);
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    padding: 24px;
  }
  
  .page-icon {
    width: 56px;
    height: 56px;
    font-size: 28px;
  }
  
  .page-title {
    font-size: 22px;
  }
  
  .form-card-body {
    padding: 10px;
  }
  
  .action-buttons {
    flex-direction: column;
  }
  
  .btn-save,
  .btn-cancel {
    width: 100%;
    justify-content: center;
  }
  
  .toast-notification {
    left: 16px;
    right: 16px;
    min-width: auto;
  }
}
/* Location Map Styles */
.location-map-container {
  width: 100%;
  height: 300px;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  border: 1px solid var(--card-border);
}

.location-map {
  width: 100%;
  height: 100%;
}

.location-search-box {
  position: relative;
  margin-bottom: 16px;
}

.search-input-wrapper {
  position: relative;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: var(--subtext);
  z-index: 1;
}

.search-input-field {
  padding-right: 35px !important;
}

.search-results-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 8px;
  max-height: 250px;
  overflow-y: auto;
  z-index: 100;
  box-shadow: 0 4px 12px var(--shadow-1);
}

.search-result-item {
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--card-border);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.search-result-item:hover {
  background: var(--hover);
}

.search-result-item small {
  color: var(--subtext);
  font-size: 11px;
}

.current-location-btn-wrapper {
  display: flex;
  justify-content: center;
}

.btn-current-location {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-current-location:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-current-location .btn-icon {
  font-size: 16px;
}
/* Why Select Items Styles */
.why-select-item {
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 12px;
  margin-bottom: 20px;
  overflow: hidden;
  transition: all 0.3s;
}

.why-select-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
  border-bottom: 1px solid var(--card-border);
}

.why-select-number {
  width: 32px;
  height: 32px;
  background: var(--primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
}

.why-select-title {
  flex: 1;
  margin: 0;
  font-weight: 600;
  color: var(--heading);
}

.remove-why-select-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--danger);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.remove-why-select-btn:hover {
  transform: scale(1.1);
  background: var(--danger-dark);
}

.why-select-body {
  padding: 20px;
}

.add-why-select-btn {
  width: 100%;
  padding: 12px;
  background: transparent;
  border: 2px dashed var(--card-border);
  border-radius: 12px;
  color: var(--primary);
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s;
}

.add-why-select-btn:hover {
  background: var(--primary-light);
  border-color: var(--primary);
}

.form-hint {
  display: block;
  font-size: 11px;
  color: var(--subtext);
  margin-top: 4px;
}
.location-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 12px;
  padding: 10px;
  background: var(--ring);
  border-radius: 12px;
  font-size: 13px;
  color: var(--primary);
}

.loading-spinner-small {
  width: 20px;
  height: 20px;
  border: 2px solid var(--card-border);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}
/* --- اصلاح بخش تم --- */
.theme-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 12px;
}

.theme-card {
  border: 2px solid var(--card-border);
  border-radius: 12px;
  padding: 8px;
  cursor: pointer;
  background: var(--card-bg);
  transition: all 0.2s ease;
  text-align: center;
}

.theme-card:hover { border-color: var(--primary); }
.theme-card.active { border-color: var(--primary); background: var(--hover-bg); }

/* پیش‌نمایش تم فقط داخل این باکس باشد */
.theme-preview {
  height: 50px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 8px;
  border: 1px solid rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
}

.theme-bar { height: 12px; width: 100%; }
.theme-content { padding: 4px; flex-grow: 1; }
.theme-line { height: 4px; width: 80%; background: rgba(150,150,150,0.2); border-radius: 2px; margin-bottom: 3px; }

/* استایل اختصاصی هر تم فقط برای باکس پیش‌نمایش */
.theme-preview-classic .theme-preview { background: #f1f5f9; }
.theme-preview-classic .theme-bar { background: #2563eb; }

.theme-preview-modern .theme-preview { background: #ffffff; }
.theme-preview-modern .theme-bar { background: #6366f1; }

.theme-preview-dark .theme-preview { background: #1e293b; }
.theme-preview-dark .theme-bar { background: #0f172a; }
.theme-preview-dark .theme-line { background: rgba(255,255,255,0.1); }

.theme-preview-light .theme-preview { background: #ffffff; border: 1px solid #e2e8f0; }
.theme-preview-light .theme-bar { background: #f8fafc; border-bottom: 1px solid #e2e8f0; }

.theme-preview-gradient .theme-preview { background: #fff; }
.theme-preview-gradient .theme-bar { background: linear-gradient(90deg, #6366f1, #ec4899); }

.theme-name { font-size: 11px; font-weight: 700; color: var(--text); }


/* --- اصلاح بخش لایوت (تفاوت بصری) --- */
.layout-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 12px;
}

.layout-card {
  border: 2px solid var(--card-border);
  border-radius: 12px;
  padding: 8px;
  background: var(--card-bg);
  cursor: pointer;
  transition: 0.2s;
  text-align: center;
}

.layout-card.active { border-color: var(--primary); background: var(--hover-bg); }

.layout-preview {
  height: 55px;
  border-radius: 8px;
  background: #f1f5f9;
  overflow: hidden;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  padding: 4px;
  gap: 4px;
}

.layout-preview .hero { background: var(--primary); border-radius: 4px; opacity: 0.7; }
.layout-preview .content { display: flex; gap: 3px; flex-grow: 1; }
.layout-preview .box { background: #cbd5e1; border-radius: 2px; }

/* تفاوت بصری لایوت‌ها */

/* پیش‌فرض: هیرو بالا + ۳ باکس کنار هم */
.layout-preview-default .hero { height: 15px; }
.layout-preview-default .content { flex-direction: row; }
.layout-preview-default .box { flex: 1; }

/* فشرده: هیرو کوچک سمت چپ + متن سمت راست */
.layout-preview-compact { flex-direction: row; align-items: center; }
.layout-preview-compact .hero { width: 30%; height: 80%; }
.layout-preview-compact .content { flex-direction: column; flex: 1; }
.layout-preview-compact .box { height: 6px; width: 100%; }

/* کامل: هیرو بزرگ + باکس‌های عمودی زیر هم */
.layout-preview-full .hero { height: 25px; }
.layout-preview-full .content { flex-direction: column; }
.layout-preview-full .box { height: 5px; width: 100%; }

/* مینیمال: بدون هیرو، فقط باکس‌های متقارن وسط‌چین */
.layout-preview-minimal .hero { display: none; }
.layout-preview-minimal .content { flex-direction: column; align-items: center; justify-content: center; }
.layout-preview-minimal .box { height: 8px; width: 60%; margin-bottom: 2px; }

.layout-name { font-size: 11px; font-weight: 700; }

</style>
